// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upgrade-modal-backdrop {
  background-color: rgba(15, 23, 42, 0.5) !important;
}

.upgrade-modal-paper {
  border-radius: 16px !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2) !important;
  overflow: hidden !important;
  max-width: 460px !important;
}

.upgrade-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f0f9ff 0%, #ffffff 100%);
}

.upgrade-modal-header-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.upgrade-modal-icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 1.35rem;
}

.upgrade-modal-icon.locked {
  background: #fff7ed;
  color: #c2410c;
}

.upgrade-modal-heading {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.upgrade-modal-subtitle {
  margin: 4px 0 0;
  font-size: 0.82rem;
  color: #64748b;
  line-height: 1.4;
}

.upgrade-modal-close {
  color: #64748b !important;
  margin-top: -4px;
}

.upgrade-modal-body {
  padding: 16px 20px 8px !important;
  background: #f8fafc;
}

.upgrade-modal-message {
  margin: 0 0 14px;
  font-size: 0.9rem;
  color: #334155;
  line-height: 1.5;
}

.upgrade-modal-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.upgrade-modal-card-title {
  margin: 0 0 8px;
  font-size: 0.85rem;
  font-weight: 700;
  color: #0f172a;
}

.upgrade-modal-perks {
  margin: 0;
  padding: 0;
  list-style: none;
}

.upgrade-modal-perks li {
  position: relative;
  padding: 5px 0 5px 18px;
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.4;
}

.upgrade-modal-perks li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.65em;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0ea5e9;
}

.upgrade-modal-price {
  margin: 10px 0 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: #0369a1;
}

.upgrade-modal-usage {
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
}

.upgrade-modal-usage strong {
  color: #0f172a;
}

.upgrade-modal-notice {
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 0.78rem;
  line-height: 1.45;
}

.upgrade-modal-actions {
  padding: 12px 20px 16px !important;
  gap: 8px;
  border-top: 1px solid #eef2f7;
  background: #fff;
}

.upgrade-modal-btn-muted {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  color: #64748b !important;
}

.upgrade-modal-btn-primary {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #0ea5e9 !important;
  box-shadow: none !important;
  min-width: 140px;
}

.upgrade-modal-btn-primary:hover {
  background: #0284c7 !important;
}

.upgrade-modal-btn-primary:disabled {
  background: #94a3b8 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Css/UpgradeModal.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".upgrade-modal-backdrop {\r\n  background-color: rgba(15, 23, 42, 0.5) !important;\r\n}\r\n\r\n.upgrade-modal-paper {\r\n  border-radius: 16px !important;\r\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2) !important;\r\n  overflow: hidden !important;\r\n  max-width: 460px !important;\r\n}\r\n\r\n.upgrade-modal-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 18px 20px 14px;\r\n  border-bottom: 1px solid #eef2f7;\r\n  background: linear-gradient(180deg, #f0f9ff 0%, #ffffff 100%);\r\n}\r\n\r\n.upgrade-modal-header-main {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  min-width: 0;\r\n}\r\n\r\n.upgrade-modal-icon {\r\n  flex-shrink: 0;\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #e0f2fe;\r\n  color: #0369a1;\r\n  font-size: 1.35rem;\r\n}\r\n\r\n.upgrade-modal-icon.locked {\r\n  background: #fff7ed;\r\n  color: #c2410c;\r\n}\r\n\r\n.upgrade-modal-heading {\r\n  margin: 0;\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.25;\r\n}\r\n\r\n.upgrade-modal-subtitle {\r\n  margin: 4px 0 0;\r\n  font-size: 0.82rem;\r\n  color: #64748b;\r\n  line-height: 1.4;\r\n}\r\n\r\n.upgrade-modal-close {\r\n  color: #64748b !important;\r\n  margin-top: -4px;\r\n}\r\n\r\n.upgrade-modal-body {\r\n  padding: 16px 20px 8px !important;\r\n  background: #f8fafc;\r\n}\r\n\r\n.upgrade-modal-message {\r\n  margin: 0 0 14px;\r\n  font-size: 0.9rem;\r\n  color: #334155;\r\n  line-height: 1.5;\r\n}\r\n\r\n.upgrade-modal-card {\r\n  background: #fff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 14px 16px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.upgrade-modal-card-title {\r\n  margin: 0 0 8px;\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n}\r\n\r\n.upgrade-modal-perks {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.upgrade-modal-perks li {\r\n  position: relative;\r\n  padding: 5px 0 5px 18px;\r\n  font-size: 0.82rem;\r\n  color: #475569;\r\n  line-height: 1.4;\r\n}\r\n\r\n.upgrade-modal-perks li::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0.65em;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: #0ea5e9;\r\n}\r\n\r\n.upgrade-modal-price {\r\n  margin: 10px 0 0;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: #0369a1;\r\n}\r\n\r\n.upgrade-modal-usage {\r\n  margin: 0;\r\n  font-size: 0.8rem;\r\n  color: #64748b;\r\n}\r\n\r\n.upgrade-modal-usage strong {\r\n  color: #0f172a;\r\n}\r\n\r\n.upgrade-modal-notice {\r\n  margin: 12px 0 0;\r\n  padding: 10px 12px;\r\n  border-radius: 10px;\r\n  background: #fff7ed;\r\n  border: 1px solid #fed7aa;\r\n  color: #9a3412;\r\n  font-size: 0.78rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n.upgrade-modal-actions {\r\n  padding: 12px 20px 16px !important;\r\n  gap: 8px;\r\n  border-top: 1px solid #eef2f7;\r\n  background: #fff;\r\n}\r\n\r\n.upgrade-modal-btn-muted {\r\n  text-transform: none !important;\r\n  font-weight: 600 !important;\r\n  border-radius: 8px !important;\r\n  color: #64748b !important;\r\n}\r\n\r\n.upgrade-modal-btn-primary {\r\n  text-transform: none !important;\r\n  font-weight: 600 !important;\r\n  border-radius: 8px !important;\r\n  background: #0ea5e9 !important;\r\n  box-shadow: none !important;\r\n  min-width: 140px;\r\n}\r\n\r\n.upgrade-modal-btn-primary:hover {\r\n  background: #0284c7 !important;\r\n}\r\n\r\n.upgrade-modal-btn-primary:disabled {\r\n  background: #94a3b8 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
